import React from 'react';
import Slider from 'react-animated-slider';
import 'react-animated-slider/build/vertical.css';

const content = [
  {
    title: "Minden ami fa...",
    description:
      "közvetlenül a gyártótól!",
    button: "Munkáink",
    link: "https://photos.app.goo.gl/QnfxfgZqGzpn5pKU9",
    image: "./img/slider/02.jpg"
  },
  {
    title: "Több, mint 30 év",
    description:
      "tapasztalattal",
    button: "Munkáink",
    link: "https://photos.app.goo.gl/QnfxfgZqGzpn5pKU9",
    image: "./img/slider/03.jpg"
  }
];

export default () => (
  <Slider className="slider-wrapper" autoplay={6000}>
            {content.map((item, index) => (
              <div
                key={index}
                className="slider-content"
                style={{ background: `url('${item.image}') no-repeat center center` }}
              >
                <div className="inner">
                  <h1>{item.title}</h1>
                  <p>{item.description}</p>
                  <button onClick={()=> window.open(item.link, "_blank")}>
                    <span className="shine"></span>
                    <span>
                      {item.button}
                    </span>
                  </button>
                </div>
              </div>
            ))}
        </Slider>
);
